function linearGradient(color: string, colorState: any, angle: number = 310) {
  return `linear-gradient(${angle}deg, ${color}, ${colorState})`;
}

export default linearGradient;
